import { ChainId, isTestEnv } from '../constant';
import { Client } from './type';

export default {
    [ChainId.mainnet]: {
        [Client.graph]: '',
        [Client.lazpad]: 'https://api.lazpad.fun/lazai',
        [Client.agent]: isTestEnv
            ? 'https://laz-chat-test-wlk9n.ondigitalocean.app'
            : 'https://laz-chat-prod-9nyyk.ondigitalocean.app',
        [Client.pump]: isTestEnv
            ? 'https://pump-api-test.netswap.io/graphql'
            : 'https://api-openlaunch.lazpad.fun/graphql',
    },
    [ChainId.testnet]: {
        [Client.graph]: isTestEnv
            ? 'https://lazbubu-backend-b3z67.ondigitalocean.app/'
            : 'https://lazbubu-api.lazai.network/',
        [Client.lazpad]: 'https://api.lazpad.fun/lazai',
        [Client.agent]: isTestEnv
            ? 'https://laz-chat-test-wlk9n.ondigitalocean.app'
            : 'https://laz-chat-prod-9nyyk.ondigitalocean.app',
        [Client.pump]: isTestEnv
            ? 'https://pump-api-test.netswap.io/graphql'
            : 'https://api-openlaunch.lazpad.fun/graphql',
    },
};
